<script>
import ModelChildIndex from "../../models/children/index";

export default {
  extends: ModelChildIndex,
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("unloads.plural"));
      }
    },
    resourceRoute: { default: "unloads" },
    modelVariable: { default: "unload" },
    tableMinHeight: { type: Number, default: 85.5 }, // 42.5 + 43
    tableHeight: { type: Number, default: 214.5 }, // 42.5 + (43 * 4)
    denyCreate: { type: Boolean, default() {
      return true
    } },
    hideTableHeader: { type:  Boolean, default: true },
    values: {
      type: Array,
      default() {
        return [];
      }
    },
    showProps: {
      default() {
        return {
          cardTitle: this.lodash.startCase(this.$t("unloads.singular")),
          resourceRoute: { default: "unloads" },
          modelVariable: "unload",
          modelMapped: require("@/router/views/unload/show.vue").default.computed.modelMapped.bind(this),
          denyEdit: { type: Boolean, default() { return false } },
          denyDelete: true
        };
      }
    }
  },
  data() {
    return {
      sortBy: "ordered_at",
      sortDesc: true
    };
  },
  computed: {
    columns() {
      return {
        ["unload"]: [
          {
            key: "id",
            label: this.lodash.startCase(this.$t("tickets.sale_order_id")),
            thStyle: { minWidth: "125px" },
            component: {
              props: ["item"],
              template: '<router-link :to="`/unloads/${item.id}`">{{ `${item.id }` }}</router-link>'
            }
          },
          {
            key: "trip_id",
            label: this.lodash.startCase(this.$t("tickets.trip_id"))
          },
          {
            key: "ordered_at",
            label: "Tanggal Bongkar",
            thStyle: { width: "150px" },
            formatter: value => {
              return this.$moment
                .utc(value)
                .local()
                .format("DD MMM YYYY");
            }
          },
          {
            key: "trip.customer.name",
            label: "Tujuan",
            component: {
              props: ["item"],
              methods: {
                format({ type, customer }) {
                  if (type === "hybrid") return "-";
                  return customer.name ?? "-";
                }
              },
              template: "<span>{{format(item)}}</span>"
            }
          },
          {
            key: "sale_item_total_quantity",
            label: "Biomasa Bongkar",
            thStyle: { minWidth: "100px" },
            formatter: value => `${this.$numeral(value / 1000).format("0,0.[00]")} ${this.$t("units.ton")}`
          }
        ]
      };
    }
  },
  methods: {
    store(value) {
      return this.$axios.post(`/tickets/${this.$route.params.key}/trips`, value);
    },
    update(value) {
      return this.$axios.put(`/tickets/${this.$route.params.key}/trips/${this.getModelKey(value)}`, value);
    },
    delete(value) {
      return this.$axios.delete(`/tickets/${this.$route.params.key}/trips/${this.getModelKey(value)}`);
    },
    fetchModels(page = 1) {
      return this.$axios
        .get(`/sale_orders?ticket_id__eq=${this.$route.params.key}`, {
          params: {
            page: page,
            per_page: this.perPage,
            search: this.search,
            sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
            with_sub_product: "1",
            with: [
              "creator",
              "customer",
              "purchase_payments",
              "ticket",
              "ticketable",
              "tickets.sale_orders.sale_payments",
              "sale_items",
              "sale_items.purchase_item",
              "trip.customer"
            ].join(","),
            type__in: "unload,cash,harvest,deposit_goods",
            ...this.filterParams
          }
        })
        .then(response => {
          const {
            data: { data, meta }
          } = response;
          this.models = data.map(datum => {
            return {
              ...datum
            };
          });
          this.page = Number(meta.current_page);
          this.perPage = Number(meta.per_page);
          this.from = Number(meta.from);
          this.total = Number(meta.total);

          this.stats = [];

          return response;
        })
        .catch(error => {
          this.failedAlert(error);
          return null;
        });
    }
  }
};
</script>
